import MoreOptionHorizontal from "components/icons/MoreOptionHorizontal";
import { timeFormat } from "helpers/dataHelper";
import { Menu, Dropdown } from "antd";
import Colors from "assets/Colors";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { buildUserName } from "../../../../helpers/hooks";
import s from "./styles";

function CardWorker({
  item,
  labelDelete,
  labelEdit,
  setWorkerToEdit,
  setAddWorkerModalOpen,
  onDeleteRequest,
}) {
  const { t } = useTranslation();
  const { roles, updateDatetime } = item;

  function applyItemStyle(selected) {
    return {
      height: "45px",
      color: selected && Colors.text_on_secondary,
      marginBottom: "10px",
      borderRadius: "2px",
    };
  }

  const handleDeleteItem = (item) => {
    const itemDelete = {
      element: { ...item },
    };
    onDeleteRequest(itemDelete);
  };

  const handleEditItem = (item) => {
    setWorkerToEdit(item);
    setAddWorkerModalOpen(true);
  };

  const role = (roles && roles.length > 0 && roles[0]) || undefined;

  const menu = (
    <Menu
      style={{
        overflow: "auto",
        padding: "8px",
        paddingBottom: 0,
        minWidth: "147px",
        textAlign: "center",
      }}
    >
      <Menu.Item
        key="edit"
        onClick={() => handleEditItem(item)}
        style={applyItemStyle()}
      >
        {labelEdit || t("components.common.CardEmployees.edit")}
      </Menu.Item>
      <Menu.Item
        disabled={role === "root"}
        key="delete"
        onClick={() => handleDeleteItem(item)}
        style={{ ...applyItemStyle(), color: Colors.notification_failed }}
      >
        {labelDelete || t("components.common.CardEmployees.delete")}
      </Menu.Item>
    </Menu>
  );

  const fullName = buildUserName(item);
  const nameInitials = useMemo(() => {
    const words = fullName.split(" ");
    if (words.length <= 3) {
      return words.map((word, index) => (index > 2 ? "" : word[0])).join("");
    }
    return `${words[0][0]}${words[words.length - 2][0]}${
      words[words.length - 1][0]
    }`;
  }, [fullName]);

  return (
    <s.Container onClick={() => handleEditItem(item)}>
      <s.ContainerOption>
        <s.Div onClick={(e) => e.stopPropagation()}>
          <Dropdown
            placement="bottomRight"
            overlay={menu}
            trigger={["click"]}
            arrow
          >
            <div style={{ cursor: "pointer", height: "15px" }}>
              <MoreOptionHorizontal />
            </div>
          </Dropdown>
        </s.Div>

        <s.ContainerImage>
          <s.borderImage>
            <s.containerInitials>{nameInitials}</s.containerInitials>
          </s.borderImage>
        </s.ContainerImage>

        <s.ContainerInfo>
          <s.ContainerName>{fullName}</s.ContainerName>
          <s.Info
            style={{
              marginTop: "5px",
            }}
          >
            {t(`components.common.CardEmployees.${role}`)}
          </s.Info>
          <s.Info
            style={{
              marginTop: "15px",
            }}
          >
            {timeFormat(updateDatetime)}
          </s.Info>
        </s.ContainerInfo>
      </s.ContainerOption>
    </s.Container>
  );
}

export default CardWorker;
